import './form-message.scss';
import templateUrl from './form-message.html';

/**
 * Inline form error or success message, typically placed in a form
 * above all form fields. Re-uses showToast directive's template + styling.
 * Cannot be combined with ng-if: use ng-show or move ng-if to a parent element.
 *
 * @example `<form-message type="error">You are banned.</form-message>`
 *
 */
export default /* @ngInject */ function formMessage() {
    return {
        templateUrl: templateUrl,
        transclude: true,
        scope: true,
        link: function(scope, element, attrs) {
            scope.type = `${attrs.type} inline`;
        }
    };
}



// WEBPACK FOOTER //
// ./forms/directives/form-message.js